export enum WorkingDaysCalculationMethod {
Method1,
Method2,
Method3,
}
